/**
 * @ethora/chat-component eagerly initializes Firebase Cloud Messaging (FCM) at
 * module import time. Its internal getMessaging() runs isSupported(), which
 * requires a secure context with full Push API support (serviceWorker,
 * PushManager, Notification, ServiceWorkerRegistration.showNotification,
 * PushSubscription.getKey). Mobile Safari/iOS lacks these outside an installed
 * PWA, and a plain-HTTP LAN-IP dev origin is not a secure context — in either
 * case the SDK throws `messaging/unsupported-browser` instead of degrading.
 *
 * The library wraps the call in try/catch, but the error is thrown inside a
 * floating .then() callback, so it escapes as an unhandled promise rejection.
 * This dashboard does not use FCM push notifications, so the failure is benign.
 * This predicate identifies that specific error so we can drop it in both the
 * browser's unhandledrejection handler and Sentry's beforeSend.
 */
export const FCM_UNSUPPORTED_BROWSER_CODE = "messaging/unsupported-browser";

export function isFcmUnsupportedError(value: unknown): boolean {
  return (
    typeof value === "object" &&
    value !== null &&
    "code" in value &&
    (value as { code?: unknown }).code === FCM_UNSUPPORTED_BROWSER_CODE
  );
}
